import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';
import {
    StyledContentImage,
    StyledContentWrapper,
} from './horizontal-content-item/horizontal-content-item.style';
import { StyledHeader } from '../../atoms/section-headline/section-headline.style';

export const StyledContentModuleSection = styled.section`
    max-width: 1200px;
    margin: 0px auto;
    @media ${mediaQueries.tabletAndUp} {
        padding: 0 15px;
    }
    /* css for odd copy item */
    article:nth-of-type(odd) {
        ${StyledContentImage} {
            @media ${mediaQueries.tabletAndUp} {
                width: 50%;
                float: left;
                padding-right: 20px;
            }
        }
    }

    /* css for even copy item */
    article:nth-of-type(even) {
        ${StyledContentImage} {
            @media ${mediaQueries.tabletAndUp} {
                float: right;
                padding-right: 10px;
                padding-left: 20px;
                width: calc(50% + 20px);
            }
        }
        ${StyledContentWrapper} {
            @media ${mediaQueries.desktopAndUp} {
                flex-direction: row-reverse;
            }
        }
    }
`;

export const StyledContentItemsWrapper = styled.div`
    background: ${(props) => props.theme.shades.white};
    padding: 20px 15px;
    @media ${mediaQueries.tabletAndUp} {
        padding: 45px 20px;
    }
    @media ${mediaQueries.desktopAndUp} {
        padding: 45px 50px;
    }
`;
export const StyledSectionHeadlineWrapper = styled.div`
    ${StyledHeader} {
        @media ${mediaQueries.phone} {
            padding-bottom: 5px !important;
        }
    }
`;
